import { render, staticRenderFns } from "./TkPackbackTour.vue?vue&type=template&id=3b040203&"
import script from "./TkPackbackTour.vue?vue&type=script&lang=js&"
export * from "./TkPackbackTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports